// client/src/utils/currency.js
// Site currency is South African Rand.
export const CURRENCY_SYMBOL = 'R';

export const formatCurrency = (amount) => `${CURRENCY_SYMBOL}${Number(amount || 0).toFixed(2)}`;

// Returns a whole-number savings percentage if compareAtPrice is meaningfully
// higher than price, otherwise null (nothing to show).
// Prices are VAT-inclusive, so an order's vat_amount is normally the VAT
// already contained in its total. Orders placed before that change had VAT
// added on top instead - detected from their own figures, so their invoices
// still add up.
export const vatWasAddedOnTop = (order) => {
  const vat = Number(order.vat_amount);
  if (!vat) return false;
  const beforeVat = Number(order.subtotal) - Number(order.discount_amount || 0) + Number(order.shipping_fee || 0);
  return Math.abs(Number(order.total_amount) - (beforeVat + vat)) < 0.01;
};

export const getSavingsPercent = (price, compareAtPrice) => {
  const p = Number(price);
  const c = Number(compareAtPrice);
  if (!c || c <= p) return null;
  return Math.round(((c - p) / c) * 100);
};
